import type { ValueOf } from "type-fest";

import { buildAction, dispatch } from "./iframeHelpers";

export const OTP_TRACKING_EVENT = {
  PASSCODE_CONTINUE_CLICK: "click_continue_login_w_passcode",
  // eslint-disable-next-line sonarjs/no-hardcoded-passwords -- False positive
  LOGIN_WITH_PASSWORD_CLICK: "click_login_w_password",
  VIEWED_CONFIRM_PASSCODE: "viewed_confirm_login_w_passcode",
  CONFIRM_LOGIN_CLICK: "click_confirm_login_w_passcode",
  RESEND_PASSCODE_CLICK: "click_resend_login_w_passcode",
} as const;

export type OtpTrackingEvent = ValueOf<typeof OTP_TRACKING_EVENT>;

export type OtpTrackingHandler = (eventName: OtpTrackingEvent) => void;

const OTP_FORM_ACTIONS = {
  TRACK_OTP: "TRACK_OTP",
} as const;

export const trackOtp = (eventName: OtpTrackingEvent) =>
  dispatch(buildAction(OTP_FORM_ACTIONS.TRACK_OTP)(eventName));
